import React from 'react'
import { Box } from '@mui/system'
import './Header.css'
import Typography from '@mui/material/Typography';
import CopyrightIcon from '@mui/icons-material/Copyright';

const Footer = () => {
  return (
    <Box bgcolor="primary.dark" className="footer">
          
          <Typography variant="subtitle2" gutterBottom component="div" color="primary.main" >
             &#169; 2022-23 XFlix | All Right Reserved.
      </Typography>    
    </Box>
  )
}

export default Footer